import { Button } from "./Button";
import { useAppDispatch } from "../app/hooks";
import { getGameStatus } from "../app/slices/appSlice";
import { ReactElement } from "react";
import { giEvent, ymEvent } from "../app/utils/metrix";

export const Welcome = (): ReactElement => {
  let dispatch = useAppDispatch()

  const next = () => {
    giEvent('START_igr');
    ymEvent('welcome_screen_start_click');
    dispatch(getGameStatus({}))
  }


  return (
    <div className={'welcome rel'}>
      <div className={'pb_welcome-bubble bubble bubble_purple bubble_bottom'}>
        <h1 className={'headline font_beige'}>Подготовься<br/> к ценовыжимательной ночи!</h1>
        <span className={'font_white'}>Жми на кнопку и выжимай<br/> свою выгоду!</span>
        <div className={'stamp'}/>
      </div>
      <div className={'welcome__machine-wrap'}>
        <div className={'welcome__machine'}>
          <div className={'welcome__wires'}/>
        </div>
      </div>
      <Button cssClass={'button_green button_welcome'} clickEvent={() => {next()}}>Начать</Button>
    </div>
  )
}